module.exports = __webpack_public_path__ + "static/media/dav_logo.357a647c.png";